export default {
  namespaced: true,
  state: {
    results: []
  },
  getters: {
    getShortList(state) {
      return state.results;
    }
  },
  mutations: {
    setShortList(state, shortlist) {
      if (shortlist?.length) {
        state.results = shortlist;
      } else {
        state.results = [];
      }
    },
    clearShortList(state) {
      state.results = [];
    }
  },
  actions: {
    updateShortList({ commit }, shortlist) {
      commit('setShortList', shortlist);
    },
    clearShortList({ commit }) {
      commit('clearShortList');
    }
  }
};
